<template>
    <div>
        <div class="form-group ">
            <label>{{ __("forms.SatisfactionSurvey.name") }}</label>
            <input type="text" class="form-control" name="kPISegment[name]" required v-model="dataSegmentation.name"
                :disabled="is_archived">
        </div>
        <div class="form-group">
            <label>{{ __("forms.KPISegments.type_calculation") }}</label>
            <div class="row">

                <!-- If persisted and typology != number, show just calculation step -->
                <div class="col-10" v-if="is_persisted">

                    <select class="form-control" required name="kPISegment[type_segments]" @change="setStaticTypology()"
                        v-model="dataSegmentation.type_segments" :disabled="is_archived">
                        <option value="step">{{ __("forms.KPISegments.calculation_step") }}</option>
                        <option v-if="dataSegmentation.typology == 'number'" value="line">
                            {{ __("forms.KPISegments.calculation_line") }}</option>
                    </select>
                </div>
                <div class="col-10" v-if="!is_persisted">
                    <select class="form-control" required name="kPISegment[type_segments]" @change="setStaticTypology()"
                        v-model="dataSegmentation.type_segments" :disabled="is_archived">
                        <option value="">{{ __("misc.select") }}</option>
                        <option value="step">{{ __("forms.KPISegments.calculation_step") }}</option>
                        <option value="line">{{ __("forms.KPISegments.calculation_line") }}</option>
                    </select>
                </div>
                <div class="col-1">
                    <button type="button"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history mx-1 hrt-button"
                        @click="openNote(__('forms.KPISegments.explain_type_calculation'))">
                        <i class="fas fa-info-circle"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="form-group" v-if="dataSegmentation.type_segments == 'line'">
            <div class="row">
                <div class="col-10">
                    <input type="checkbox" name="kPISegment[automatic_percentage_calculation]" value="1"
                        v-model="dataSegmentation.automatic_percentage_calculation" :disabled="is_archived">
                    <label>{{ __("forms.KPISegments.automatic_percentage_calculation") }}</label>
                </div>
                <div class="col-1">
                    <button type="button"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history mx-1 hrt-button"
                        @click="openNote(__('forms.KPISegments.explain_auto_calculation'))">
                        <i class="fas fa-info-circle"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="form-group" v-else>
            <input type="checkbox" disabled>
            <label>{{ __("forms.KPISegments.automatic_percentage_calculation") }}</label>
        </div>
        <div class="form-group">
            <input type="checkbox" name="kPISegment[is_standard]" value="1" v-model="dataSegmentation.is_standard"
                :disabled="is_archived">
            <label>{{ __("forms.KPISegments.is_standard") }}</label>
        </div> 
        <div class="form-group">
            <div class="row">
                <div v-if="!is_persisted" class="col-10">
                    <!-- CREATE MODE -->
                    <div class="form-group" v-if="dataSegmentation.type_segments != 'line'">
                        <label>{{ __("forms.KPISegments.typology") }}</label>
                        <!-- Only in create you can edit this select -->
                        <select class="form-control" required name="kPISegment[typology]"
                            v-model="dataSegmentation.typology">
                            <option value="">{{ __("misc.select") }}</option>
                            <option v-for="(typology) in typologies" :value="typology.id" v-bind:key="typology.id">
                                {{ typology.value }}
                            </option>
                        </select>
                    </div>
                    <div v-else>
                        <input name="kPISegment[typology]" value="number" type="hidden">
                    </div>
                </div>
                <div v-else class="col-10">
                    <div v-if="dataSegmentation.type_segments != 'line'" class="form-group">
                        <label>{{ __("forms.KPISegments.typology") }}</label>
                        <select class="form-control" disabled required name="kPISegment[typology]"
                            v-model="dataSegmentation.typology">
                            <option v-for="(typology) in typologies" disabled :value="typology.id"
                                v-bind:key="typology.id">
                                {{ typology.value }}
                            </option>
                        </select>
                        <input name="kPISegment[typology]" :value="dataSegmentation.typology" type="hidden">
                    </div>
                    <div v-else>
                        <input name="kPISegment[typology]" :value="dataSegmentation.typology" type="hidden">
                    </div>
                </div>
                <div class="col-1" v-if="dataSegmentation.type_segments != 'line'">
                    <button type="button" style="margin-top: 23px;"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history mx-1 hrt-button"
                        @click="openNote(__('forms.KPISegments.explain_typology_calculation'))">
                        <i class="fas fa-info-circle"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label> {{ __("forms.KPISegments.origin_segmentation_standard") }}</label>
            <select class="form-control" name="kPISegment[standard_segment_id]"
                v-model="dataSegmentation.standard_segment_id" :disabled="is_archived">
                <option value="">{{ __("misc.select") }}</option>
                <option v-for="standard in standard_segmentations" :value="standard.id">
                    {{ standard.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.dataSegmentation = this.kpi_segment;
        this.setStaticTypology();
    },
    props: {


        typologies: {
            type: Array,
            required: true
        },
        standard_segmentations: {
            type: Array,
            required: true
        },
        kpi_segment: {
            type: [Object, Array],
            required: true
        },
        is_persisted: {
            type: Boolean,
            required: true
        },
        is_archived: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            dataSegmentation: {}
        }
    },
    methods: {
        setStaticTypology() {
            if (this.dataSegmentation.type_segments == "line") {
                //block to number
                this.dataSegmentation.typology = "number";

            }
        },
        openNote(note) {
            Vue.swal.fire({
                title: note,
            });
        },
    }
}
</script>

<style></style>
